import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiHeart } from 'react-icons/fi';
import { Layout } from '../components/layout/Layout';
import { BackButton } from '../components/BackButton';
import { useAuth } from '../hooks/useAuth';
import { getSavedDecks, unsaveDeck } from '../services/firestoreService';
import { DECKS } from '../data/stimuli';
import '../styles/dashboard.css';

export const SavedDecksPage = () => {
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  const [savedDeckNames, setSavedDeckNames] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!currentUser) return;
    getSavedDecks(currentUser.uid).then((res) => {
      if (res.success) setSavedDeckNames(res.data);
      setLoading(false);
    });
  }, [currentUser]);

  const handleUnsave = useCallback(async (e, deckName) => {
    e.stopPropagation();
    if (!currentUser) return;
    setSavedDeckNames((prev) => prev.filter((n) => n !== deckName));
    await unsaveDeck(currentUser.uid, deckName);
  }, [currentUser]);

  const savedDecks = DECKS.filter((d) => savedDeckNames.includes(d.name));

  return (
    <Layout>
      <div className="dashboard">
        <BackButton />
        <div className="dash-header" style={{ paddingTop: 8 }}>
          <div className="dash-header-text">
            <h1 className="dash-title">Saved Decks</h1>
            <p className="dash-subtitle">Your pinned decks — tap to start a session</p>
          </div>
        </div>

        {loading ? null : savedDecks.length === 0 ? (
          <div className="saved-empty">
            <FiHeart size={40} style={{ color: '#C4878A', marginBottom: 12 }} />
            <p>No saved decks yet.</p>
            <p style={{ fontSize: '0.9rem', color: '#B8B0B2' }}>
              Tap the heart icon on any deck from the home screen to save it here.
            </p>
            <button
              style={{
                marginTop: 20,
                padding: '10px 22px',
                background: '#8B2635',
                color: '#fff',
                border: 'none',
                borderRadius: 10,
                fontSize: 14,
                fontWeight: 600,
                cursor: 'pointer',
                fontFamily: 'inherit',
              }}
              onClick={() => navigate('/dashboard')}
            >
              Browse Decks
            </button>
          </div>
        ) : (
          <div className="deck-grid">
            {savedDecks.map((deck) => (
              <div
                key={deck.name}
                className="deck-card"
                onClick={() => navigate(`/session/${encodeURIComponent(deck.name)}`)}
              >
                <div className="deck-card-face" style={{ backgroundColor: deck.color }}>
                  {deck.coverImage && (
                    <img
                      src={deck.coverImage}
                      alt={deck.name}
                      className="deck-card-cover-img"
                      onError={e => { e.currentTarget.style.display = 'none'; }}
                    />
                  )}
                  <button
                    className="deck-save-btn saved"
                    onClick={(e) => handleUnsave(e, deck.name)}
                    title="Remove from Saved Decks"
                  >
                    <FiHeart size={13} />
                  </button>
                </div>
                <div className="deck-card-info">
                  <div className="deck-card-badge" style={{ background: deck.color || '#F3E8EA' }}>
                    <span className="deck-card-emoji">{deck.emoji}</span>
                  </div>
                  <div className="deck-card-name">{deck.name}</div>
                  <div className="deck-card-count">{deck.items?.length || 0} cards</div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </Layout>
  );
};
